<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<div class="col-md-2">
	<input type="number" class="form-control" [(ngModel)]="promocodeApplyLimit" (change)="onPromocodeApplyLimitChange()">
</div>
<chart [data]="promocodeChartData.data" [options]="promocodeChartData.options" [sextant]="'promocodeChart'" [url]="filter.currentUrl"></chart>

<br><hr><br>

<div class="col-md-2">
	<input type="number" class="form-control" [(ngModel)]="flashPromoLimit" (change)="onFlashPromoApplyLimitChange()">
</div>
<chart [data]="flashPromoChartData.data" [options]="flashPromoChartData.options" [sextant]="'flashPromoChart'" [url]="filter.currentUrl"></chart>

<br><hr><br><br>

<loading [isLoad]="statsLoader"></loading>
<table class="table table-bordered" *ngIf="!statsLoader && stats.length > 0" [sextant]="'stats'" [url]="filter.currentUrl">
	<thead>
		<tr>
			<th>{{ 'adminstat.common.Promocode' | translate }}</th>
			<th>{{ 'adminstat.common.summary' | translate }}</th>
			<th>{{ 'adminstat.common.sites' | translate }}</th>
		</tr>
	</thead>
	
	<tbody>
		<tr *ngFor="let stat of stats; let i = index">
			<td>
				<table class="table">
					<thead>
						<tr>
							<th>{{ 'adminstat.billing.billing.mark' | translate }}</th>
							<th>{{ 'adminstat.billing._promocode.used' | translate }}</th>
							<th>{{ 'adminstat.billing.billing.Total' | translate }}</th>
						</tr>
					</thead>
					
					<tbody>
						<tr>
							<td>
								<strong>{{ stat.mark }}</strong>
							</td>
	
							<td>
								{{ stat.totalCount }}
							</td>
	
							<td>
								<ng-container *ngIf="stat.mark != 'flashPromo' && stat.mark != 'flashFromFriend'">
									{{ stat.usages }}	
								</ng-container>
							</td>
						</tr>
					</tbody>
				</table>

				<ngb-accordion #acc="ngbAccordion">
					<ngb-panel title="{{ 'adminstat.billing._promocode.more' | translate }}">
						<ng-template ngbPanelContent>
							<table class="table">
								<tr>
									<td>
										{{ 'adminstat.common.date_create' | translate }}
									</td>

									<td>
										{{ stat.dateCreate }}
									</td>
								</tr>

								<tr>
									<td>
										{{ 'adminstat.billing._promocode.date_end' | translate }}
									</td>

									<td>
										<ng-container *ngIf="stat.mark != 'flashPromo' && stat.mark != 'flashFromFriend'">
											{{ stat.dateTo }}
										</ng-container>
									</td>
								</tr>

								<tr>
									<td>
										{{ 'adminstat.billing._promocode.maxUsages' | translate }}
									</td>

									<td>
										<ng-container *ngIf="stat.mark != 'flashPromo' && stat.mark != 'flashFromFriend'">
											{{ stat.maxUsages }}
										</ng-container>
									</td>
								</tr>
							</table>
							
							<hr/>
							
							<ng-container *ngIf="stat.variants">
								<table class="table" *ngFor="let tariff of stat.variants | keys">
									<thead>
										<tr>
											<th [attr.colspan]="6">{{ tariff }}</th>
										</tr>
										
										<tr>
											<th>{{ 'adminstat.billing.billing.tariffVariant' | translate }}</th>
	
											<ng-container *ngFor="let currency of currencyList">
												<th>{{ currency }}</th>
											</ng-container>
										</tr>
									</thead>

									<tbody *ngIf="stat.variants[tariff]">
										<tr *ngFor="let variant of stat.variants[tariff] | keys">
											<ng-container *ngIf="variant != 'tariffId'">
												<td>
													{{ variant }}
												</td>
												
												<td *ngFor="let currency of currencyList">
													{{ stat.variants[tariff][variant][currency.toUpperCase()] || 0 }}
												</td>
											</ng-container>
										</tr>
									</tbody>
								</table>
							</ng-container>
						</ng-template>
					</ngb-panel>
				</ngb-accordion>
			</td>

			<td>
				<div class="tariff-accordion">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onOpenTariffs($event, stat.mark)">
						<ngb-panel title="{{ 'adminstat.billing._promocode.by tariff variant' | translate }}">
							<ng-template ngbPanelContent>
								<loading [isLoad]="tariffsLoader[stat.mark]"></loading>
	
								<table class="table" *ngIf="!tariffsLoader[stat.mark] && tariffList[stat.mark]" [sextant]="'variants'" [url]="filter.currentUrl">
									<thead>
										<tr>
											<th>{{ 'adminstat.billing.billing.tariffVariant' | translate }}</th>
	
											<ng-container *ngFor="let currency of currencyList">
												<th>{{ currency }}</th>
											</ng-container>
										</tr>
									</thead>
	
									<tbody>
										<tr *ngFor="let variant of tariffList[stat.mark] | keys" [class]="variant == 'total' ? 'bg-primary text-white' : ''">
											<td>
												{{ variant }}
											</td>
	
											<ng-container *ngFor="let currency of currencyList">
												<th>{{tariffList[stat.mark][variant][currency] || 0 }}</th>
											</ng-container>
										</tr>
									</tbody>
								</table>
	
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
			</td>

			<td>
				<div class="site-accordion">
					<ngb-accordion #acc="ngbAccordion" (panelChange)="onOpenSites($event, stat.mark)">
						<ngb-panel title="{{ 'adminstat.common.show all' | translate }} ({{ stat.sitesCount }})">
							<ng-template ngbPanelContent>
								<loading [isLoad]="sitesLoader[stat.mark]"></loading>
	
								<table class="table" *ngIf="!sitesLoader[stat.mark] && siteList[stat.mark]" [sextant]="'sites'" [url]="filter.currentUrl">
									<thead>
										<tr>
											<th>{{ 'adminstat.billing.billing.Detail' | translate }}</th>
											<th>{{ 'adminstat.common.domainUrl' | translate }}</th>
										</tr>
									</thead>
	
									<tbody>
										<tr *ngFor="let siteData of siteList[stat.mark]">
											<td>
												<button type="button" class="btn btn-default btn-xs">
													<i class="fa fa-eye" aria-hidden="true" (click)="showPaidDetails(siteData)"></i>
												</button>
											</td>
	
											<td>
												<site_info [siteUrl]="siteData.domainUrl"></site_info>
											</td>
										</tr>
									</tbody>
								</table>
							</ng-template>
						</ngb-panel>
					</ngb-accordion>
				</div>
			</td>
		</tr>
	</tbody>
</table>
